// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/ModelNav/modelNav.scss
// module id = 1382
// module chunks = 10 21